import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import * as moment from "moment";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-billing-summary",
  templateUrl: "./billing-summary.component.html",
})
export class BillingSummaryComponent implements OnInit {
  today = new Date();
  filterStartDate = "01";
  filterMonth = "";
  filterYear = "";
  currentYear = parseInt(moment(this.today).format("YYYY"));
  yearList = [];
  historyList = [];
  monthList = [
    { text: "January", value: "01" },
    { text: "February", value: "02" },
    { text: "March", value: "03" },
    { text: "April", value: "04" },
    { text: "May", value: "05" },
    { text: "June", value: "06" },
    { text: "July", value: "07" },
    { text: "August", value: "08" },
    { text: "September", value: "09" },
    { text: "October", value: "10" },
    { text: "November", value: "11" },
    { text: "December", value: "12" },
  ];
  month: any = {};
  filterMonthName = "";
  errorMessage = "";
  offset = 0;
  tcCountryCode = "";

  constructor(private appService: AppService, private datepipe: DatePipe) {}
  formatter: any;
  ngOnInit() {
    this.tcCountryCode = localStorage.getItem("country_code")
    this.offset = +localStorage.getItem("offsetzone");
    this.getHistoryList();
    this.getMonthName(this.filterMonth);
    this.getMonthList();
    this.formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });

    console.log(this.tcCountryCode);
    
  }

  getMonthNameDiv(val: any) {
    const month = val.toString();
    this.monthList.forEach((obj) => {
      if (obj.value === month) {
        return obj.text;
      }
    });
  }

  getMonthList() {
    for (let i = 0; i < 5; i++) {
      this.yearList.push(this.currentYear - i);
    }
  }

  getMonthName(val) {
    this.monthList.forEach((obj) => {
      if (obj.value === val) {
        this.filterMonthName = obj.text;
      }
    });
  }

  refreshReport() {
    this.filterYear = "";
    this.filterMonth = "";
    this.getHistoryList();
  }

  getHistoryList() {
    let startdate = "";
    let enddate = "";
    if (this.filterMonth && this.filterYear) {
      startdate =
        this.filterYear + "-" + this.filterMonth + "-" + this.filterStartDate;
      enddate = moment(new Date(+this.filterYear, +this.filterMonth, 0)).format(
        "YYYY-MM-DD"
      );
    }
    const data = {
      pageNumber: 0,
      pageRecord: 0,
      procedureId: "",
      startDate: startdate,
      endDate: enddate,
      tcId: localStorage.getItem("testCenterId"),
      feesType: "all",
    };

    this.appService.getBillingHistory(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"] && res["entity"].length > 0) {
            this.errorMessage = "";
            this.historyList = res["entity"];
          } else {
            this.historyList = [];
            this.errorMessage = "No record found";
            setTimeout(() => {
              this.errorMessage = "";
            }, 5000);
          }
        } else {
          this.historyList = [];
          this.errorMessage = "No record found";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  convertutctolocal(value) {
    let flag;
    if (value) {
      const zoneDate = new Date(value);
      flag = this.datepipe.transform(
        zoneDate.setMinutes(zoneDate.getMinutes() + this.offset),
        "MMM dd, yyyy"
      );
    }
    return flag;
  }
}
